import {createApp} from 'vue'
import App2 from './App.vue'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'

import zhCn from 'element-plus/es/locale/lang/zh-cn';

import {addRoutes, router} from '@/router/index'

import store from '@/store/index.js'

import setting from '@/settings.js'




const getToken = ()=>{
    return 0;
}


/*
router.addRoute({
    path:'/book/list',
    component:import('@/pages/book/List.vue')
})
*/


router.beforeEach(async(to,from,next)=>{

    if(to.meta.title){
        document.title = `${to.meta.title}--`+setting.title+`系统`;
    }else{
        document.title = setting.title+`系统`;
    }

   // console.log('------------to paths：',to.path)

    const token = store.getters['user/getToken'];

   // console.log('------------current token：',token)

    if(!token){
        if( to.path !== '/login' && to.path !== '/register' && to.path !== '/check' && to.path !== '/verify' && to.path !== '/test' && to.name !== 'NotFound') {
            next('/login')
        }else{
            next()
        }
    }else{
        const menus = await store.dispatch('user/getMenusInfo');
        console.log('获取到的动态menu：',menus);
        let hasNewRoute = addRoutes(menus);
        if( to.path === '/login'){
            next('/')
        }else{
            hasNewRoute ? next(to.fullPath) : next();
        }
    }

})

  const app = createApp(App2);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

app.use(router).use(store).use(ElementPlus,{ locale: zhCn }).mount('#app')
